export default __webpack_public_path__ + "static/SectionTwo_02_02@2x-bbdbda15ad4ef2a90d4b0874a4f02cf7.png";